<template>
  <div id="app">

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>Class Raporu</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search">
              </v-text-field>



              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>



                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel İndir</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>


            </v-toolbar>
          </v-flex>





          <v-container fluid="">



            <v-form ref="formcariyegore" v-model="valid" lazy-validation>
              <v-card flat>
                <v-flex>
                  <v-layout row wrap="" class="pa-1 project overdue">

                    <v-flex xs12 sm6 md2>
                      <tarihcomp :etiket="'Başlangıç Tarihi'" v-bind:defaultvalue="'ok'"
                        v-bind:value="Rapor.BaslangicTarih" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                        v-model="Rapor.BaslangicTarih"></tarihcomp>
                    </v-flex>

                    <v-flex xs12 sm6 md2>
                      <tarihcomp :etiket="'Bitiş Tarihi'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                        v-bind:defaultvalue="'ok'" v-bind:value="Rapor.BitisTarih" v-model="Rapor.BitisTarih">
                      </tarihcomp>
                    </v-flex>

                    <v-flex xs12 sm6 md3>


                      <v-radio-group v-model="Rapor.TarihTip" row column>
                        <v-radio label="Uçuş Tarihine Göre" :value="false"></v-radio>
                        <v-radio label="Satış Tarihine Göre" :value="true"> </v-radio>
                      </v-radio-group>
                    </v-flex>

                    <v-flex>
                      <v-layout>
                        <div v-if="load1">
                          <v-btn color="info" @click="getList()" fab small="" dark>
                            <v-icon>search</v-icon>
                          </v-btn>
                        </div>

                        <!-- <v-badge color="white" :overlap="true">
                        <template v-slot:badge>
                          <v-icon v-if="filtrevarmi" large color="green">
                            check_circle_outline </v-icon>
                        </template>

                        <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                          @click="filtrele()" color="info" fab dark>
                          <v-icon>filter_list</v-icon>
                        </v-btn>
                        <v-tooltip bottom="" :activator="el" v-model="tooltip">
                          <span>Arama Filtresi Ekle</span>
                        </v-tooltip>



                      </v-badge> -->





                        <!--
                      <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                        @click="filtrele()" color="info" fab dark>
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span>Arama Filtresi Ekle</span>
                      </v-tooltip> -->




                      </v-layout>
                    </v-flex>

                    <v-flex v-show="EkstreHesap.RaporDvzTip == 1 || EkstreHesap.RaporDvzTip == 2" xs12 sm12 md12>
                      <v-layout justify-end="" fill-height="">
                        <v-btn @click="detayaGit()" flat color="info">Genel toplamlarını görmek için tıklayınız.</v-btn>
                      </v-layout>

                    </v-flex>

                  </v-layout>

                </v-flex>
              </v-card>
            </v-form>

            <v-layout row wrap>

              <v-flex pt-2 xs12 sm12 md12>

                <v-card flat>
                  <v-layout row wrap class="project overdue">


                    <v-flex sm12 xs12 md12>


                      <v-data-table dense :headers="headers" class="elevation-1" :rows-per-page-items=[50,100]
                        :loading="progress" :items="items" :search="search3">
                        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                        <template slot="items" slot-scope="props">
                          <td class="text-xs-left">{{ props.item | gethavayolu }}</td>
                          <td class="text-xs-center">{{ props.item.BusinessAdet }}</td>
                          <td class="text-xs-right">{{ props.item.BusinessTutar | moneyformat}}{{getparabirimi()}}</td>
                          <td class="text-xs-right">{{ props.item.BusinessServis | moneyformat}}{{getparabirimi()}}</td>
                          <td class="text-xs-center">{{ props.item.EconomicAdet }}</td>
                          <td class="text-xs-right">{{ props.item.EconomicTutar | moneyformat}}{{getparabirimi()}}</td>
                          <td class="text-xs-right">{{ props.item.EconomicServis | moneyformat}}{{getparabirimi()}}</td>
                          <td class="text-xs-center">{{ props.item.FirstClassAdet }}</td>
                          <td class="text-xs-right">{{ props.item.FirstClassTutar | moneyformat}}{{getparabirimi()}}
                          </td>
                          <td class="text-xs-right">{{ props.item.FirstClassServis | moneyformat}}{{getparabirimi()}}
                          </td>
                        </template>

                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                          Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                        </v-alert>
                      </v-data-table>

                    </v-flex>

                  </v-layout>
                </v-card>

              </v-flex>

              <v-flex v-if="items.length>0" pt-2 xs12 sm12 md12>
                <v-card flat>
                  <v-layout row wrap class="pa-3 project overdue">
                    <v-flex pt-1 pb-1 sm112 xs12 md12>
                      <v-layout row wrap>
                        <v-flex pa-1 sm10 xs12 md9>
                          <div class="title font-weight- grey--text">
                            Genel Toplamlar
                          </div>
                        </v-flex>


                      </v-layout>
                    </v-flex>



                    <v-flex xs12 md12>
                      <v-layout row wrap>

                        <v-flex xs12 md6>
                          <v-layout row wrap>

                            <v-flex xs12 sm12 md6>
                              <v-layout row wrap>
                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-left>
                                    <div class="body-2 	 justify-center   grey--text">Business Toplamlar</div>
                                  </v-layout>
                                </v-flex>




                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md6>
                              <v-layout row wrap>

                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-left>
                                    <div class="justify-center body-2 grey--text">Economy Toplamlar</div>
                                  </v-layout>
                                </v-flex>






                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>

                        <v-flex xs12 md6>
                          <v-layout row wrap>


                            <v-flex xs12 sm12 md6>
                              <v-layout row wrap>

                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-left>
                                    <div class="body-2 	 justify-center   grey--text">First Class Toplamlar</div>
                                  </v-layout>
                                </v-flex>







                              </v-layout>
                            </v-flex>


                            <v-flex xs12 sm12 md6>
                              <v-layout row wrap>

                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-left>
                                    <div class="justify-center body-2  grey--text">Genel Toplam</div>
                                  </v-layout>
                                </v-flex>








                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>

                      </v-layout>
                    </v-flex>


                    <v-flex xs12 md12>
                      <v-divider></v-divider>
                    </v-flex>

                    <v-flex xs12 md12>
                      <v-layout row wrap>

                        <v-flex xs12 md6>
                          <v-layout row wrap>

                            <v-flex xs12 sm12 md6>
                              <v-layout row wrap>
                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-left>
                                    <div class="caption	 justify-center   grey--text">Adet:</div>
                                  </v-layout>
                                </v-flex>

                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-end>
                                    <div class="justify-end align-center fill-height caption ">
                                      {{Dip.BusAdet}}</div>
                                  </v-layout>
                                </v-flex>

                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-left>
                                    <div class="caption	 justify-center   grey--text">Tutar</div>
                                  </v-layout>

                                </v-flex>

                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-end>
                                    <div class="justify-end caption ">{{Dip.BusTutar | moneyformat}}{{getparabirimi()}}
                                    </div>
                                  </v-layout>
                                </v-flex>

                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-left>
                                    <div class="caption	 justify-center   grey--text">Servis</div>
                                  </v-layout>

                                </v-flex>

                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-end>
                                    <div class="justify-end caption ">{{Dip.BusServis | moneyformat}}{{getparabirimi()}}
                                    </div>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md6>
                              <v-layout row wrap>

                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-left>
                                    <div class="justify-center caption grey--text">Adet:</div>
                                  </v-layout>
                                </v-flex>

                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-end>
                                    <div class="justify-center caption ">{{Dip.EcoAdet}}</div>
                                  </v-layout>
                                </v-flex>




                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-left>
                                    <div class="justify-center caption grey--text">Tutar:</div>
                                  </v-layout>
                                </v-flex>

                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-end>
                                    <div class="justify-center caption ">
                                      {{Dip.EcoTutar | moneyformat}}{{getparabirimi()}}</div>
                                  </v-layout>
                                </v-flex>


                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-left>
                                    <div class="justify-center caption grey--text">Servis</div>
                                  </v-layout>
                                </v-flex>

                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-end>
                                    <div class="justify-center caption ">
                                      {{Dip.EcoServis | moneyformat}}{{getparabirimi()}}</div>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>

                        <v-flex xs12 md6>
                          <v-layout row wrap>


                            <v-flex xs12 sm12 md6>
                              <v-layout row wrap>

                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-left>
                                    <div class="caption	 justify-center   grey--text">Adet</div>
                                  </v-layout>
                                </v-flex>

                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-end>
                                    <div class="justify-end caption ">{{Dip.FirstAdet}}</div>
                                  </v-layout>
                                </v-flex>


                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-left>
                                    <div class="caption	 justify-center   grey--text">Tutar:</div>
                                  </v-layout>

                                </v-flex>

                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-end>
                                    <div class="justify-end caption ">
                                      {{Dip.FirstTutar | moneyformat}}{{getparabirimi()}}</div>
                                  </v-layout>
                                </v-flex>

                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-left>
                                    <div class="caption	 justify-center   grey--text">Servis:</div>
                                  </v-layout>

                                </v-flex>

                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-end>
                                    <div class="justify-end caption ">
                                      {{Dip.FirstServis | moneyformat}}{{getparabirimi()}}</div>
                                  </v-layout>
                                </v-flex>



                              </v-layout>
                            </v-flex>


                            <v-flex xs12 sm12 md6>
                              <v-layout row wrap>

                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-left>
                                    <div class="justify-center caption grey--text">Adet:</div>
                                  </v-layout>
                                </v-flex>

                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-end>
                                    <div class="justify-center caption ">{{Dip.GenAdet}}</div>
                                  </v-layout>
                                </v-flex>




                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-left>
                                    <div class="justify-center caption grey--text">Tutar:</div>
                                  </v-layout>
                                </v-flex>

                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-end>
                                    <div class="justify-center caption ">
                                      {{Dip.GenTutar | moneyformat}}{{getparabirimi()}}</div>
                                  </v-layout>
                                </v-flex>


                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-left>
                                    <div class="justify-center caption grey--text">Servis:</div>
                                  </v-layout>
                                </v-flex>

                                <v-flex pa-1 xs6 md6>
                                  <v-layout justify-end>
                                    <div class="justify-center caption ">
                                      {{Dip.GenServis | moneyformat}}{{getparabirimi()}}</div>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>

                      </v-layout>
                    </v-flex>

                  </v-layout>
                  <v-divider></v-divider>
                </v-card>


              </v-flex>





            </v-layout>
          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
          </v-snackbar>

        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import helpers from "@/components/app/customcomp/helpers.js"

  export default {
    data() {
      return {

        Dip: {
          BusAdet: 0,
          BusTutar: 0,
          BusServis: 0,
          EcoAdet: 0,
          EcoTutar: 0,
          EcoServis: 0,
          FirstAdet: 0,
          FirstTutar: 0,
          FirstServis: 0,
          GenAdet: 0,
          GenTutar: 0,
          GenServis: 0,
        },
        Rapor: {
          BaslangicTarih: null,
          BitisTarih: null,
          CariKodu: null,
          TarihTip: false // false : uçuş tarihi , true : satistarihi
        },

        filtrevarmi: false,
        search: '',
        dovizToplamlar: [],



        headers: [{
            text: 'Havayolu',
            value: 'HavayoluKodu'
          },
          {
            text: 'Business Adet',
            value: 'BusinessAdet'
          },
          {
            text: 'Business Tutar',
            value: 'BusinessTutar',
            align: 'right'
          },
          {
            text: 'Business Servis',
            value: 'BusinessServis',
            align: 'right'
          },
          {
            text: 'Economy Adet',
            value: 'EconomicAdet'
          },
          {
            text: 'Economy Tutar',
            value: 'EconomicTutar',
            align: 'right'
          },
          {
            text: 'Economy Servis',
            value: 'EconomicAdet',
            align: 'right'

          }, {
            text: 'First Adet',
            value: 'FirstClassAdet'
          }, {
            text: 'First  Tutar',
            value: 'FirstClassTutar',
            align: 'right'
          }, {
            text: 'First Servis',
            value: 'FirstClassServis',
            align: 'right'
          }

        ],


        EkstreHesap: {

          SirketKodu: null,
          Cari: {
            Kod: null
          },
          BaslangicTarih: null,
          BitisTarih: null,
          IstenilenReferanslar: [],
          IstenmeyenReferanslar: [],
          Masraflar: [],
          Gruplar: [],
          NoGruplar: [],
          Evraklar: [],
          Tarihler: 0, // 0 : Tarih,  1 : Vade , 2 : Fatura Tarihi
          RaporTip: false, // false : Detay, true : Ozet
          RaporDvzTip: 0, // 0 : tl, 1 : dvz, 2 : tl+dvz
          BsYolcuDetay: false,
          SifirTutar: false,
          DevirGoster: false,
          AltHesapGosterme: false,
          TlAta: false,
          CoperKayit: false,
          ProgramTip: 0 //0 : Hepsi,1 : Sadece Coper, 2 : Coper Hariç
        },
        devirborc: 0,
        deviralacak: 0,
        devirbakiye: 0,
        donemborc: 0,
        donemalacak: 0,
        donembakiye: 0,
        toplamborc: 0,
        toplamalacak: 0,
        toplambakiye: 0,
        valid: true,

        statecari: [],
        searchcari: '',
        Carihesap: '',
        text1: null,


        loading: false,
        progress: false,
        renk1: 'info',
        items: [],
        load: false,
        load1: true,
        search3: '',
        dialogfiltre: false,
        hesapkodu: [],
        Referans: [],
        masrafmerkezi: [],


        tumsirketler: false,

        anahesap: [],
        hesapgurubu: [],
        evraktipi: [],
        mizan: '',
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        tooltip: false,
        el: null,
      }
    },

    beforeMount: beforeMount,
    components: {
      tarihcomp
    },
    mounted() {
      // this.el = this.$refs.fab.$el

    },
    watch: {

    },
    filters: {
      gethavayolu: function (val) {
        return val.HavayoluKodu + '-' + val.HavayoluAdi
      },
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },
    methods: {
      getparabirimi() {
        return helpers.getparabirimi()
      },
      getList: getList,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
    }
  }

  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {
      CompanyCode: credentials.SirketKodu
    }


    this.$http.post(auth.API_URL + 'api/Reference/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.Referans = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })


    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgurubu = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/doctype/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.evraktipi = response.body

    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })



  }

  function filtrekayit() {
    this.filtrevarmi = true
    this.getList();
    this.dialogfiltre = false
  }

  function filtreiptal() {
    this.filtrevarmi = false
    this.dialogfiltre = false
  }

  function getList() {

    var bastarih = new Date(this.Rapor.BaslangicTarih)
    var bittarih = new Date(this.Rapor.BitisTarih)

    if (bastarih <= bittarih) {

      if (this.$refs.formcariyegore.validate()) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.Rapor.CariKodu = credentials.CariBilgi.Kod

        this.progress = true

        var params = this.Rapor

        this.load1 = false

        this.$http.post(auth.API_URL + 'api/Dot9/ClassReport', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.progress = false
          this.load1 = true

          if (response.body.length > 0) {
            this.items = response.body

             this.Dip.BusTutar =0
              this.Dip.BusServis =0
              this.Dip.EcoAdet =0
              this.Dip.EcoTutar =0
              this.Dip.EcoServis =0
              this.Dip.FirstAdet =0
              this.Dip.FirstTutar =0
              this.Dip.FirstServis =0
              this.Dip.GenAdet =0
              this.Dip.GenTutar =0
              this.Dip.GenServis =0


            response.body.forEach(element => {
              this.Dip.BusAdet += element.BusinessAdet
              this.Dip.BusTutar += element.BusinessTutar
              this.Dip.BusServis += element.BusinessServis
              this.Dip.EcoAdet += element.EconomicAdet
              this.Dip.EcoTutar += element.EconomicTutar
              this.Dip.EcoServis += element.EconomicServis
              this.Dip.FirstAdet += element.FirstClassAdet
              this.Dip.FirstTutar += element.FirstClassTutar
              this.Dip.FirstServis += element.FirstClassServis
              this.Dip.GenAdet += element.BusinessAdet + element.EconomicAdet + element.FirstClassAdet
              this.Dip.GenTutar += element.BusinessTutar + element.EconomicTutar + element.FirstClassTutar
              this.Dip.GenServis += element.BusinessServis + element.EconomicServis + element.FirstClassServis
            });



          } else {
            this.text1 = 'Kayıt Bulunamadı.';
            this.snackbar = true;
            this.progress = false;
            this.load1 = true;
            this.items = [];
          }
          this.progress = false

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true

            this.load1 = true
            this.progress = false

          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.load1 = true
            this.progress = false
          }
        })

      }

    } else {

      this.load1 = true

      this.text1 = 'Başlangıç tarihi bitiş tarihinden büyük olamaz...'
      this.snackbar = true

    }



  }

  function getListExcel() {
      var bastarih = new Date(this.Rapor.BaslangicTarih)
    var bittarih = new Date(this.Rapor.BitisTarih)

    if (bastarih <= bittarih) {

      if (this.$refs.formcariyegore.validate()) {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.Rapor.CariKodu = credentials.CariBilgi.Kod

        this.progress = true

        var params = this.Rapor

        this.load1 = false

      this.$http.post(auth.API_URL + 'api/Dot9/ClassReportExcel', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        },
        responseType: "arraybuffer"
      }).then((response) => {
        this.load = false
        this.load1 = true
        this.progress = false
        var blob = new Blob([response.data], {
          type: 'application/xlsx'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "ClassRapor.xlsx";
        link.click();

      }, (response) => {
        if (response.status === 0) {
          this.text = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false

        } else {
          this.text = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false

        }
      })

      }

    } else {

      this.load1 = true

      this.text1 = 'Başlangıç tarihi bitiş tarihinden büyük olamaz...'
      this.snackbar = true

    }



  }



  function beforeMount() {}
</script>

<style>
  .project.complete {
    border-left: 4px solid #039BE5;
  }

  .project.ongoing {
    border-left: 4px solid orange;
  }

  .project.overdue {
    border-left: 4px solid tomato;
  }
</style>